export default __webpack_public_path__ + "static/media/banner4.cacf3db0.webp";